import { ResetPasswordOutput, resetPassword } from 'aws-amplify/auth';
import { useState } from 'react';
import { Utils } from 'src/utils/utils';

export const useSendCode = (initialPhoneNumber: string = '') => {
  const [phoneNumber, setPhoneNumber] = useState<string>(initialPhoneNumber);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>('');

  const sendCode = async (): Promise<ResetPasswordOutput> => {
    if (!phoneNumber) {
      setError('Required');
      throw Error('Phone number is required');
    }

    try {
      setLoading(true);
      setError('');

      const formattedPhoneNumber = Utils.formatPhone(phoneNumber);
      const output = await resetPassword({ username: formattedPhoneNumber });
      return output;
    } catch (err: any) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { phoneNumber, setPhoneNumber, sendCode, loading, error, setError };
};
